import React from 'react'
import {get, map} from 'lodash'
import {useController} from '@data-client/react'
import {apiReply, toast, useForm} from '../lib'
import {ActionHeader, RequiredFieldNote, SimpleForm, SubmitButton} from '../components'
import {SignUpResource} from '../lib/model'
import {SignUpSchema} from '../lib/schema/Profile'
import {SignUpForm} from '../lib/form/Profile'
import {Paper, Container, Box, Button} from '@mui/material'

export default function SignUpPage() {
  const api = useController()
  const [captcha, setCaptcha] = React.useState({x1: 0, x2: 0, x3: 0})
  React.useEffect(() => {
    const x1 = Math.floor(Math.random() * 10)
    const x2 = Math.floor(Math.random() * 10)
    const x3 = Math.floor(Math.random() * 10)
    setCaptcha({x1, x2, x3})
    SignUpForm.captcha.placeholder = `What is ${x1} + ${x2} - ${x3}?`
  }, [])
  const form = useForm(SignUpSchema)

  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-expect-error */
  const onSubmit = form.handleSubmit(async (data: SignUpSchema) => {
    if (Number(data.captcha) !== captcha.x1 + captcha.x2 - captcha.x3) {
      form.setError('captcha', {type: 'manual', message: 'WRONG!'}, {shouldFocus: true})
      return
    }
    const msg = toast('loading', 'Signing Up')
    const reply = await apiReply(() => api.fetch(SignUpResource.create, data))
    if (reply.error) {
      if (reply.error?.name) {
        msg.fail(`name: ${reply.error.name}`)
        form.setError('name', {type: 'manual', message: reply.error.name})
        return
      }
      if (reply.error?.email) {
        msg.fail(`email: ${reply.error.email}`)
        form.setError('email', {type: 'manual', message: reply.error.email})
        return
      }
      msg.fail(reply.error)
      return
    }
    msg.succeed('Logging In...')
    setTimeout(() => {
      window.location.assign('/')
    }, 2000)
  })

  return (
    <Container maxWidth="md">
      <ActionHeader title="Sign Up"/>
      <Paper elevation={3} sx={{py: 3, px: 2}}>
        <RequiredFieldNote />
        <form onSubmit={onSubmit}>
          <SimpleForm form={form} fields={map(['name', 'password', 'email', 'captcha'], i => get(SignUpForm, i))} />
          <Box mt={3} textAlign="center">
            <SubmitButton form={form}>Sign Up</SubmitButton>
          </Box>
        </form>
        <Box display="flex" justifyContent="end" mt={3}>
          <Button href="/signin">Already a member?</Button>
        </Box>
      </Paper>
    </Container>
  )
}
